import { render, staticRenderFns } from "./LicenseQuickViewDrawer.vue?vue&type=template&id=1447f56c&"
import script from "./LicenseQuickViewDrawer.vue?vue&type=script&lang=js&"
export * from "./LicenseQuickViewDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports